import { Box, Typography } from '@mui/material';

type ContractInfoBlockProps = {
  label: string;
  value: string;
};

export const ContractInfoBlock: React.FC<ContractInfoBlockProps> = ({ label, value }) => (
  <Box sx={{ flex: 1 }}>
    <Typography variant="subtitle2" color="textPrimary" sx={{
      fontSize: 14
    }}>
      {value}
    </Typography>
    <Typography variant="subtitle2" color="textSecondary" sx={{
      fontSize: 14
    }}>
      {label}
    </Typography>
  </Box>
);
